module.exports = __webpack_public_path__ + "static/media/ensaladas.9078d55e.jpg";